import { Component, Input } from '@angular/core';
import { Literature } from '../../core/search-literatures.model';

import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'page-item',
  standalone: true,
  imports: [I18nModule],
  templateUrl: './page-item.component.html',
  styleUrl: './page-item.component.scss',
})
export class PageItemComponent {
  @Input() literature!: Literature;

  /**
   * Returns a thumbnail URL suitable for <img>.
   * If the provided thumbnail is a PDF URL (ends with .pdf optionally followed by query/hash),
   * convert it to the corresponding JPG that follows the pattern:
   *   .../file.pdf  => .../file-pdf.jpg
   * preserving any query/hash.
   *
   * This uses a regex that replaces ".pdf" only when followed by end/query/hash.
   */
  get thumbnailSrc(): string {
    const src =
      (this.literature && (this.literature.thumbnail || this.literature.documentLink || this.literature.url)) || '';

    if (!src) {
      return '';
    }

    // Replace ".pdf" before end-of-string, query or hash with "-pdf.jpg"
    // Examples:
    //  foo.pdf                    -> foo-pdf.jpg
    //  foo.pdf?ver=1              -> foo-pdf.jpg?ver=1
    //  foo.pdf#page=2             -> foo-pdf.jpg#page=2
    return src.replace(/\.pdf(?=($|\?|#))/i, '-pdf.jpg');
  }
}
